/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Canceleventrefunds2Inputs */

const en_canceleventrefunds2 = /** @type {(inputs: Canceleventrefunds2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Paid tickets worth ${i?.amount} are refunded automatically, and there is no payout.`)
};

const de_canceleventrefunds2 = /** @type {(inputs: Canceleventrefunds2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bezahlte Tickets im Wert von ${i?.amount} werden automatisch erstattet, und es gibt keine Auszahlung.`)
};

/**
* | output |
* | --- |
* | "Paid tickets worth {amount} are refunded automatically, and there is no payout." |
*
* @param {Canceleventrefunds2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const canceleventrefunds2 = /** @type {((inputs: Canceleventrefunds2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canceleventrefunds2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_canceleventrefunds2(inputs)
	return de_canceleventrefunds2(inputs)
});
export { canceleventrefunds2 as "cancelEventRefunds" }